import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updatePageTitle } from "../../../modules/legacyUtils";
import OpenBankingConnector from "../../interactive/OpenBankingConnector";
import OpenBankingUnavailable from "../../interactive/OpenBankingUnavailable";
import { useOpenBankingRequisitions } from "../../../hooks/useOpenBankingRequisitions";
import { trackEvent } from "../../../modules/tracking";
import { AnalyticsEvents } from "../../../modules/analyticsEvents";
export default function OpenBankingIndex() {
    const location = useLocation();
    const { requisitions, requisitionsError, postRedirectContent, postRedirectError, isLoading, refetchRequisitions } = useOpenBankingRequisitions();
    const nonOverviewRequisitions = requisitions.filter(req => !req.overview);
    useEffect(() => {
        updatePageTitle('Open Banking');
        const ref = new URLSearchParams(location.search).get('ref');
        if (!ref || ref === 'null') {
            trackEvent(AnalyticsEvents.screenViews.openBankingInitialStep());
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => { if (isLoading)
        return; if (postRedirectError) {
        trackEvent(AnalyticsEvents.screenViews.openBanking('Failed'));
    }
    else if (postRedirectContent) {
        trackEvent(AnalyticsEvents.screenViews.openBanking('Success'));
    } }, [isLoading, postRedirectContent, postRedirectError]);
    if (isLoading)
        return null;
    if (requisitionsError) {
        return /*#__PURE__*/ React.createElement(OpenBankingUnavailable, { onRetry: refetchRequisitions });
    }
    return /*#__PURE__*/ React.createElement(OpenBankingConnector, { requisitions: nonOverviewRequisitions, postRedirectContent: postRedirectContent, postRedirectError: postRedirectError });
}
